export default {
  methods: {
    transLabelToName(label) {
      switch (label) {
        case 'businessStr':
          return 'Business Type'
        case 'name':
          return 'Customer Name'
        case 'regionStr':
          return 'Region'
        case 'code':
          return 'Customer#'
        case 'countryStr':
          return 'Country'
        case 'currency':
          return 'Currency'
        case 'paymentTermReq':
          return 'Payment Term Req'
        case 'totalAR':
          return 'Total AR'
        case 'totalBacklog':
          return 'Total Backlog'
        case 'totalExposure':
          return 'Total Exposure'
        case 'validAmount':
          return 'Current Credit Line'
        case 'averageOverdueRatioLast12':
          return 'Average Overdue Ratio in last 12 mths(%)'
        case 'overdueAmount60':
          return 'Overdue Amount >= 60 Days'
        case 'paytrendOrAverageAging':
          return 'Paytrend or Average Aging'
        case 'totalOverdueAmt60':
          return 'Total Overdue AMT >= 60 Days'
        case 'tdbRating':
          return 'TDB Rating'
        case 'latestFYTotalProfit':
          return 'Latest Financial Year Total Profit'
        case 'latestFDate':
          return 'Latest Financial Date'
        case 'latestFYTotalRevenue':
          return 'Latest Financial Year Total Revenue'
        case 'latestFYTotalCapital':
          return 'Latest Financial Year Total Capital'
        case 'insuranceAmount':
          return 'Insurance Amount'
        case 'collateralAmount':
          return 'Collateral Amount '
        case 'expirationDate':
          return 'Expire Date'
        case 'sp':
          return 'S&P'
        case 'moodysStr':
          return 'Moody'
        case 'fitchStr':
          return 'Fitch'
        case 'frisk':
          return 'Frisk'
        case 'zscore':
          return 'Z-Score'
        case 'zscoreSecond':
          return 'Z’-Score'
        case 'scoreCard':
          return 'Scorecard'
        case 'globalCustomerRating':
          return 'GCR'
        case 'theoreticalLimit':
          return 'Theoretical Limit'
        case 'amount':
          return 'Credit Limit Amount'
        case 'amountDetail':
          return 'Request Amount($)'
        case 'typeStr':
          return 'Credit Category'
        case 'indateEnd':
          return 'Expire Date'
        case 'requestTypeStr':
          return 'Credit Request Type'
        case 'applyTypeStr':
          return 'Credit Type'
        case 'total':
          return 'Company Quantity'
        case 'fileName':
          return 'CreditLine List '
        case 'requestType':
          return 'Credit Request Type'
        case 'approveType':
          return 'Credit Category'
        case 'partialAmount':
          return 'Partial Amount'
        case 'decisionType':
          return 'Decision Type'
        case 'insuranceProviderStr':
          return 'Provider'
        case 'collateralCategoryStr':
          return 'Collateral Category'
        case 'customerType':
          return 'Customer Type'
        default:
          return 'Valid Amount'
      }
    },
  },
}
